import humanize from 'humanize-number';

export const getMaskedNumber = n => {
  let numero;

  n = n?.replace(/\./g, '').replace(/\-/g, ''); // eslint-disable-line

  if (n) {
    numero = parseInt(n, 10);
    numero = numero.toString();
  } else {
    numero = n;
  }

  const length = numero?.length;

  if (length) {
    const numeros = Array.from(numero);
    let nuevos = numeros;

    if (length > 7) {
      const part3 = numeros.slice(length - 1);
      const part2 = numeros.slice(length - 4, length - 1);
      const part1 = numeros.slice(length - 7, length - 4);
      const part0 = numeros.slice(0, length - 7);
      nuevos = [...part0, '.', ...part1, '.', ...part2, '-', ...part3];
    } else if (length === 7) {
      const part3 = numeros.slice(length - 1);
      const part2 = numeros.slice(length - 4, length - 1);
      const part1 = numeros.slice(length - 7, length - 4);
      nuevos = [...part1, '.', ...part2, '-', ...part3];
    } else if (length === 6) {
      const part2 = numeros.slice(length - 3, length);
      const part1 = numeros.slice(length - 6, length - 3);
      nuevos = [...part1, '.', ...part2];
    }

    return nuevos.join('');
  } else {
    return numero;
  }
};

export function openModal() {
  document.querySelector('#modal-login').style.display = 'block';
}

export const preventSpecialChars = event => {
  const regex = new RegExp('[A-Za-z0-9\\s ñ]+$');
  const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }
};

export const getCurrencySymbol = moneda => {
  let symbol;

  switch (moneda) {
    case 'UYU':
      symbol = '$';
      break;
    case 'USD':
      symbol = 'U$S';
      break;
    case 'UI':
      symbol = 'UI';
      break;
    default:
      symbol = '';
      break;
  }

  return symbol;
};

export const getCurrencyName = moneda => {
  let name;

  switch (moneda) {
    case 'UYU':
      name = 'Pesos';
      break;
    case 'USD':
      name = 'Dólares';
      break;
    case 'UI':
      name = 'Un. Indexadas';
      break;
    default:
      name = 'Pesos';
      break;
  }

  return name;
};

export const capitalize = s => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const getNumberWithDots = number => {
  if (typeof number === 'string' && number.includes('.')) {
    return number;
  } else {
    return humanize(number || 0, {
      delimiter: '.',
      separator: ',',
    });
  }
};

export function getSelectedTarjeta(data) {
  let tarjetas;

  if (data?.length === 2) {
    tarjetas = 'AMBAS';
  } else if (data?.length === 1) {
    if (data[0] === 'tarjeta-si') {
      tarjetas = 'AMBAS';
    } else {
      tarjetas = '--';
    }
  } else {
    tarjetas = '--';
  }

  return tarjetas;
}

export function getSelectedTipoCuenta(tipoCuenta) {
  let cuentas;

  if (tipoCuenta?.length === 2) {
    cuentas = 'AMBAS';
  } else if (tipoCuenta?.length === 1) {
    if (tipoCuenta[0] === 'tipo_cuenta-nose') {
      cuentas = 'CA'; // NOTE: "no se que cuenta tengo" asume que tiene ambas cuentas
    } else if (tipoCuenta[0] === 'tipo_cuenta-cc') {
      cuentas = 'CC';
    } else if (tipoCuenta[0] === 'tipo_cuenta-ca') {
      cuentas = 'CA';
    } else {
      cuentas = '--';
    }
  } else {
    cuentas = '--';
  }

  return cuentas;
}
